// HTML TRIGGER IS-VISITED class and VERIFY-AGE class	
if ( typeof localStorage.ageVerified == 'string' && localStorage.ageVerified == 'true' ) { 
	document.documentElement.classList.remove('verify-age');
	if ( typeof sessionStorage.hasVisited == 'string' && sessionStorage.hasVisited == 'true' ) document.documentElement.classList.add('is-visited');
	else sessionStorage.hasVisited = 'true';
}

(function($){

	var isHome = $('body').hasClass('home'),
		isPage = $('body').hasClass('page'),
		isMobile = 'ontouchstart' in window,
		
		announcement = $('#site-announcement'),
		sixMaps = $('.sixsquare-map'),
		sliders = $('.slickSlider'),
		touchhover = $('.touchhover'),
		scrollUp = $('.scroll-up'),
		scrollDown = $('.scroll-down'),
		articleTitleContainer = $('main.main > article .title__container'),
		
		contentTop = 0,
		windowWidth = 0,
		windowHeight = 0,
		
		scdA = {};
		
		// pick random SCD Product, set CSS variables
		var p = document.getElementsByClassName('scdProduct');
		if ( p.length ) {
			if (sixScript.productsRandom) { // Random product
				p = p[Math.round( Math.random() * ( p.length - 1 ) )];
			} else p = p[0];
			var body = document.getElementsByTagName('body')[0]
			
			body.style.setProperty('--overlay', p.style.getPropertyValue('--overlay'));
			body.style.setProperty('--overlay2', p.style.getPropertyValue('--overlay2'));
			body.style.setProperty('--overlayBorder', p.style.getPropertyValue('--overlayBorder'));
			body.style.setProperty('--highlight', p.style.getPropertyValue('--highlight'));
			body.style.setProperty('--heroHighlight', p.style.getPropertyValue('--heroHighlight'));
			body.style.setProperty('--heroHighlight2', p.style.getPropertyValue('--heroHighlight2'));
			body.style.setProperty('--bodyTitle', p.style.getPropertyValue('--bodyTitle'));
			body.style.setProperty('--pattern', p.style.getPropertyValue('--pattern'));
			
			p.parentElement.classList.add('initialSlide');
			
		}
		
$(document).ready(function() {

	// BODY ANIMATION TRIGGER
	$('body').removeClass('pre-init');
	
	// Sugar Reef Promo
	if ( $('body').hasClass('page-id-533') ) {
		$(document.documentElement).on('ageVerified', function() {
			if ( $(window).scrollTop() < 10 ) {
				scrollDown.click();
			}
		});
	}

	// Age Verification trigger
	var logo = $('.header-hero .logo'),
		logoDelay = ( logo.hasClass('burst') ? 3.0 : ( logo.hasClass('sugarReef') ? 3.1 : 2.6 ) ) + 1;
		
	if ( document.documentElement.classList.contains('verify-age') ) {
		setTimeout( function () {
			$('#off-canvas').foundation('open');
		}, logoDelay * 1000 );
	} else {
		setTimeout( function() {
			$(document.documentElement).trigger('ageVerified');
		}, logoDelay * 1000 );
	}

	// Set CSS Vars
	// Pick random palette
	if ( typeof sixScript.palettes == 'object' && sixScript.palettes.length ) {
		var ps = sixScript.palettes,
			p = ps[Math.floor(Math.random() * ps.length)];
		
		$.each(p,function(i,v) {
			document.documentElement.style.setProperty('--palette' + (1+i), v);
		});
	}
	
	// Set bubble float rate
	document.documentElement.style.setProperty('--bubbleFloat', Math.round( $(document).height() / 50 ) + 's');
	
	// Random Header Hero pattern attachment class
	var patternClasses = ['topleft','topright','bottomright','bottomleft','center'];
	$('.header-hero .hero__pattern').addClass(patternClasses[Math.floor(Math.random() * patternClasses.length)]);
	
	
	// Homepage Newsletter signup
	if ( isHome ) {
		$('footer #gform_wrapper_1').siblings('p').hide();
		$('footer #gform_wrapper_1').appendTo('.header-hero .hero__inner');
		
	}

	// Slick Slider
	sliders.each(function() {
		var t = $(this),
			initialSlide = Math.max(0,t.children('.slide.initialSlide').index());
		
		t.on('init',function(e,slick){
			var t = $(this),
				h = t.height(),
				iSp = t.find('.slide.initialSlide .scdProduct');
				
			if ( slick.options.centerMode ) t.addClass('centerMode');
			if ( ! t.hasClass('hero') ) t.height(h);
			
		//	if ( t.hasClass('scdProducts') ) t.trigger('afterChange');
			
			
			if ( iSp.length ) this.style.setProperty('--arrows', iSp[0].style.getPropertyValue('--arrows'));
		
		}).on('reInit',function(e,slick) {
			var t = $(this),
				h = t.css('height','').height();
				
				if ( ! t.hasClass('hero') ) t.height(h);
		}).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			var nSlide = slick.$slides[nextSlide],
				nProduct = $(nSlide).children('.scdProduct');
				
				if ( nProduct.length ) this.style.setProperty('--arrows', nProduct[0].style.getPropertyValue('--arrows'));
		
		}).on('afterChange', function(event, slick, currentSlide) {
			var product = $(event.target).find('.slick-current .scdProduct');
			if ( product.length ) {
				product = product[0];
				var body = document.getElementsByTagName('body')[0]
				
				body.style.setProperty('--overlay', product.style.getPropertyValue('--overlay'));
				body.style.setProperty('--overlay2', product.style.getPropertyValue('--overlay2'));
				body.style.setProperty('--overlayBorder', product.style.getPropertyValue('--overlayBorder'));
				body.style.setProperty('--highlight', product.style.getPropertyValue('--highlight'));
				body.style.setProperty('--heroHighlight', product.style.getPropertyValue('--heroHighlight'));
				body.style.setProperty('--heroHighlight2', product.style.getPropertyValue('--heroHighlight2'));
				body.style.setProperty('--bodyTitle', product.style.getPropertyValue('--bodyTitle'));
				body.style.setProperty('--pattern', product.style.getPropertyValue('--pattern'));
				
			}
		}).slick({
			// Default options
			initialSlide: initialSlide,
			centerPadding: '20%',
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 600,
			accessibility: true,
			responsive: [
				{ 	breakpoint: 1680,
					settings: {
						centerPadding: '15%'
					}
				}
			]
		});
	});
	
	
	// Stacked Products Parallax
	var stackedParallax = new Rellax('.stackedProducts .scdProduct-image > img',{speed:1.5,center:true});

	
	// Easy Grid Slider
	var gS = $('.gridSlider').data('gridSliderPos',0); 
	$('<button class="gS_prev"></button><button class="gS_next"></button>').appendTo(gS).click(function(){
		var t = $(this);
		var gS = t.parent('.gridSlider');
		var cur = gS.data('gridSliderPos');
		var move = ( t.hasClass('gS_prev') ? -1 : 1 );
		var slides = gS.children('.cell');
		var maxed = ( ( gS.width() - 1 ) > ( slides.last().position().left ) );
		if ( ( ! maxed || move < 0 ) && (cur + move) >= 0 ) {
			gS.removeClass('gs-' + cur);
			gS.addClass('gs-' + (cur + move) ).data('gridSliderPos', cur + move);
		}
	});
	
	
	// Scroll Down widget
	scrollDown.click(function(){
		var t = (contentTop/400) * 800;
		$('html, body').animate({ scrollTop: contentTop }, t, 'easeInQuad');
	});
	
	// Resize with throttle
	$(window).on('resize', Foundation.util.throttle( function (event) {

		sliders.each(function() {
			var t = $(this),
				h = t.css('height','').height();
				if ( ! t.hasClass('hero') ) t.height(h);

		});

		setVH();
		
		windowHeight = $(window).height();
		contentTop = $('.header-hero').first().height();
//		articleTitleTop = $('main.main > article .title__container').offset().top;

		if ( announcement.length ) announcement.height( announcement.children('.message')[0].scrollHeight );
			
	}, 300) ).resize();
			
	// Scrolling with throttle
	$(window).on('scroll', Foundation.util.throttle( function (event) {
	
		var wTop = $(this).scrollTop();
			
		sixSquareMapCheck();
		
		if ( wTop >= 10 ) {
			$('header.header').addClass('scrolling');
		} else {
			$('header.header').removeClass('scrolling');
		}
				
		if ( wTop >= contentTop - 20 ) {
			$('header.header').addClass('scrolled');
		} else {
			$('header.header').removeClass('scrolled');
		}
		
		if ( scrollDown.offset().top > contentTop ) {
			scrollDown.addClass('collapse');
		} else {
			scrollDown.removeClass('collapse');
		}

	}, 300) ).scroll();
			
	// Scrolling 
	$(window).on('scroll', function (event) {
		
		if ( articleTitleContainer.length ) {
			var wAnchor = window.scrollY + (window.innerHeight * 0.84),
				tcBottom = articleTitleContainer.offset().top + articleTitleContainer.innerHeight();
		
			if ( wAnchor >= tcBottom ) $('main.main > article .title__container .title__innerContainer').addClass('stuck');
			else $('main.main > article .title__container .title__innerContainer').removeClass('stuck');
		}

	} ).scroll();
	
	function sixSquareMapCheck() {
		// Google Maps
		if ( sixMaps.length ) {
			sixMaps.each(function(i, el) {
				el = $(el);
				if ( el.visible('middle') ) { 
					sixSquareMapFeatures( el );
					sixMaps = sixMaps.not(this);
				}
			});
		}
	}
	
	// SVG load
	$('img.svg-load').each( function() { 
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');
		$.get({
			url: imgURL,
			cache: true,
			dataType: 'xml',
			success: function (data) {
				// Get the SVG tag, ignore the rest
				var $svg = $(data).find('svg');
				// Add replaced image's ID to the new SVG
				if(typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if(typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass);
				}
				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');
				// Replace image with new SVG
				$img.replaceWith($svg);
			}
		});
	});

	// Hide Site Announcement if dismissed this session
	if (	announcement.length 
		 &&	typeof sessionStorage.announcementClosed == 'string'
		 &&	sessionStorage.announcementClosed == announcement.data('aid') 
	   ) {
		
		announcement.removeClass('open');
		announcement = [];
	   	
	} else {
	
		// Annoucement Close
		announcement.find('.close').click(function() {
			announcement.addClass('closed');
			sessionStorage.announcementClosed = announcement.data('aid');
			announcement = [];
		});
	
	}

	// Off Canvas links: close on click. This ensures the menu is hidden when navigating back. Reducing the transition was somehow necessary. It is fixed by onClick code in nav-offcanvas-topbar.php. The callback below doesn't get called.
	$('#off-canvas a').click(function(e){
		if ( $(this).parent().hasClass('is-accordion-submenu-parent') ) return true;
		
		var t = $(this);
				
		// don't follow link	
		e.preventDefault();
		
		// Close off-canvas
		$('#off-canvas').foundation('close');
		
		// Trigger body pageLoader
//		$('body').addClass('loading');
		
		// follow link after off-canvas closes
		$('#off-canvas').on('closed.zf.offCanvas', function () {
			window.location = t.attr('href');
		});		

		return false;

	});
	
	// Off-Canvas inner: stop propagation of transitionend event causing premature transition on close
	$('.offcanvas-full-screen-inner').on('transitionend',(e)=>e.stopPropagation());

	// Off-Canvas Open [verified]
	$('#off-canvas').on('opened.zf.offCanvas', function (e) {
		
		scdA.offcanvas.rate(1).play();
	//	document.activeElement.blur();
		sixSquareMapCheck();
		
		if ( ! document.documentElement.classList.contains('verify-age') ) {
			setTimeout(function(){ document.documentElement.classList.add('is-visited'); }, 800);
		}

	});
	
	// Off-Canvas Open Ended [verified]
	$('#off-canvas').on('openedEnd.zf.offCanvas', function (e) {
		document.activeElement.blur();
		
	});

	// Off-Canvas Close [verified]
	$('#off-canvas').on('close.zf.offCanvas', function (e) {
		setTimeout( function() { scdA.offcanvas.rate(-1.3).play(); }, 400 );
	});
	
	// Off-Canvas Closed [verified]
	$('#off-canvas').on('closed.zf.offCanvas', function (e) {

	});
	
	// Off-Canvas accordion menu OPEN
//	$('#offcanvas-nav').foundation('showAll');
	
	// Touch hover methods
	if ( isMobile ) {
		touchhover.on('touchstart', function(e) {
			var t = $(this);
			
			if ( t.hasClass('hover') ) {
				return true;
			} else {
				t.addClass('hover');
				touchhover.not(this).removeClass('hover');
				e.preventDefault();
				return false;
			}
			
		});
		$('body').on('touchstart',function(e) {
			touchhover.removeClass('hover');
		});
	}
	
	// Bubbler
	var bubbleContainer = $('.bubble__container');
	if ( bubbleContainer.length ) {
		var bubble = bubbleContainer.children('.bubble'),
			bubbleH = bubble.height(),
			bubbleW = bubble.width(),
			minScale = 0.4,
			minSpacing = 80, screens = 2,
			wW = $(document).width(),
			wH = $(document).height(),
			rate = parseInt(document.documentElement.style.getPropertyValue('--bubbleFloat')),
			wProportion = Math.ceil ( 100 * (bubbleW/wW) ),
			maxL = 100 - wProportion,
			t = l = 0, scale = 1;

		while ( t < rate ) {

			if ( l > maxL ) l = Math.floor ( Math.random() * maxL );
			
			scale = Math.max(minScale,Math.round((Math.random() + 0.1)*10)/10);

			bubble.clone()
				.css({
					'animationDelay': t + 's',
					'left': l + '%'
				})
				.appendTo(bubbleContainer)
				.addClass('up')
				[0].style.setProperty("--scale", scale);
			
			l += wProportion + Math.floor ( Math.random() * maxL );
			t += 0.5 + Math.floor ( Math.random() * 4 );
		}

	}
	
	//Animation: off canvas
	scdA.offcanvas = KeyshapeJS.animate("#f8v3p0r52busyb9nxknafvdk",[{p:'d',t:[800,1300,1800],v:["path('M0,0.0034L0,0.0034C668,0,1333.23,-0.00113333,2000,0L2000,0C1083.4,-6.7886,1084.13,16.0491,0,0.0034Z')","path('M0,162L0,0.0034C667.281,0,1333.23,-0.00113333,2000,0L2000,623.505C1083.4,616.716,1084.13,178.046,0,162Z')","path('M0,92.9943L0,0.0034C666.562,0,1333.23,-0.00113333,2000,0L2000,1247.01C1083.4,1240.22,1084.13,109.04,0,92.9943Z')"],e:[[0],[1,0.28,0.905,0.645,1],[0]]}],
					"#dm39u9hl3pipos26eq1qljg9",[{p:'d',t:[300,800,1300,1800],v:["path('M0,0C1085.45,16.6789,1082.12,-7.43,2000,0L2000,0C710.891,6.34,846.084,6.37,0,0Z')","path('M0,0C1085.45,16.6789,1082.12,-7.43,2000,0L2000,130C710.891,136.34,846.084,460.37,0,454Z')","path('M0,160C1085.45,176.679,1082.12,615.075,2000,622.505L2000,942C710.891,948.34,846.084,748.37,0,742Z')","path('M0,90.9943C1085.45,107.673,1082.12,1237.58,2000,1245.01L2000,1362.01C710.891,1368.35,846.084,722.372,0,716.002Z')"],e:[[0],[0],[1,0.28,0.905,0.645,1],[0]]}],
					"#t85edz45rvqcba7xxm4rfi29",[{p:'d',t:[0,300,800,1300,1800],v:["path('M0,0C844.428,5.795,712.177,6.67,2000,0L2000,0C1333.46,0.01,666.789,0,0,0Z')","path('M0,0C844.428,5.795,712.177,6.67,2000,0L2000,69C1333.46,69.01,666.789,210,0,210Z')","path('M0,454C844.428,459.795,712.177,136.67,2000,130L2000,642C1333.46,642.01,558,1542,0,1484Z')","path('M0,742C844.428,747.795,712.177,948.67,2000,942L2000,1371C888,1371,666.789,1484,0,1484Z')","path('M0,715.001C844.428,720.796,712.177,1367.68,2000,1361.01L2000,1483.99C1333.46,1484,666.789,1484,0,1484Z')"],e:[[0],[0],[0],[1,0.28,0.905,0.645,1],[0]]}],
					{autoplay: false,autoremove:false}).range(0,1800);
	
}); // document.ready()

// window Load
$(window).on('load', function() {



}); // window.load


// Set default VH unit for mobile (Safari toolbar full height fix)
function setVH() {
	if ( isMobile && $(window).width() != windowWidth ) {
		windowWidth = $(window).width();
		var vh = window.innerHeight * 0.01; // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
}
 
// Breakpoint Change
$(window).on('changed.zf.mediaquery ready', function(event, newSize, oldSize) {
	if ( typeof newSize == 'undefined' ) newSize = Foundation.MediaQuery.current;

	if ( newSize == 'small' ) {
		
	} else if ( oldSize == 'small' ) {

	} 
	if ( newSize && oldSize ) { // actual change, not first call (ready)
		
		// Easy Grid Slider reset
		$('.gridSlider').each( function() {
			var gS = $(this);
			var cur = gS.data('gridSliderPos');
			gS.removeClass('gs-' + cur).data('gridSliderPos',0);
		});
		
	}
});


// Gravity Forms: FORM POST RENDER (This includes initial form load, going to the next/previous page on multi-page forms, form rendered with validation errors, confirmation message displayed, etc.)
$(document).bind('gform_post_render', function(event,formID){
	
	
});
		
// fn: Visible
$.fn.visible = function(type) {
	var t            = $(this);
	if ( typeof t.offset() != "object" ) { console.log('visible: not object.'); console.log(this); return false; }
	var	$w            = $(window),
		viewTop       = $w.scrollTop(),
		viewBottom    = viewTop + $w.height(),
		_height		  = t.height(),
		offset        = t.offset(),
		_top          = offset.top,
		_middle		  = _top + (_height/2),
		_bottom       = _top + _height,
		_10			  = _height*0.1;
		
		if ( offset.left <= (0 - t.width()) || offset.left > $w.width() ) return false;
		
		switch (type) {
			case 'top': return (_top +_10 >= viewTop) && (_top < viewBottom);
			case 'middle': return (_middle >= viewTop) && (viewBottom >= _middle);
			//case 'full':
			default: return (_bottom <= viewBottom) && (_top >= viewTop);
		}
};

// Google Maps Callback fn
window.sixSquareMapInit = function () {
	// Create a new StyledMapType object, passing it an array of styles,
	// and the name to be displayed on the map type control.
	var styledMapType = new google.maps.StyledMapType([
	  {
		"elementType": "geometry",
		"stylers": [{
			"color": "#f5f5f5"
		  }]
	  },
	  {
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#616161"
		  }]
	  },
	  {
		"elementType": "labels.text.stroke",
		"stylers": [{
			"color": "#f5f5f5"
		  }]
	  },
	  {
		"featureType": "administrative.land_parcel",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#bdbdbd"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [{
			"color": "#eeeeee"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "labels.text",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#757575"
		  }]
	  },
	  {
		"featureType": "poi.business",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi.business",
		"elementType": "labels.text",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi.park",
		"elementType": "geometry",
		"stylers": [{
			"color": "#e5e5e5"
		  }]
	  },
	  {
		"featureType": "poi.park",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  },
	  {
		"featureType": "road",
		"elementType": "geometry",
		"stylers": [{
			"color": "#ffffff"
		  }]
	  },
	  {
		"featureType": "road",
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "road.arterial",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#757575"
		  }]
	  },
	  {
		"featureType": "road.highway",
		"elementType": "geometry",
		"stylers": [{
			"color": "#dadada"
		  }]
	  },
	  {
		"featureType": "road.highway",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#616161"
		  }]
	  },
	  {
		"featureType": "road.local",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  },
	  {
		"featureType": "transit",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "transit.line",
		"elementType": "geometry",
		"stylers": [{
			"color": "#e5e5e5"
		  }]
	  },
	  {
		"featureType": "transit.station",
		"elementType": "geometry",
		"stylers": [{
			"color": "#eeeeee"
		  }]
	  },
	  {
		"featureType": "water",
		"elementType": "geometry",
		"stylers": [{
			"color": "#80bac5"
		  }]
	  },
	  {
		"featureType": "water",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  }
	], {name: 'Styled Map'});
	
	sixMaps.each(function() {
	
		var googleMap = new google.maps.Map( this, {
			zoom: 15,
			center: new google.maps.LatLng( sixScript.gmap_lat, sixScript.gmap_long ),
			mapTypeId: 'roadmap',
			mapTypeControl: false,
			fullscreenControl: false,
			streetViewControl: false,
			scrollwheel: false,
			"featureType": "poi.business",
			"stylers": [
				{
					"visibility": "off"
				}
			]		
		});

		//Associate the styled map with the MapTypeId and set it to display.
		googleMap.mapTypes.set('styled_map', styledMapType);
		googleMap.setMapTypeId('styled_map');
		
		$(this).data('gmap', googleMap);
	
	});

}
// Google Maps Feature / pin / display fn
function sixSquareMapFeatures( map ) {

	if ( typeof map != 'object' ) return false;
	
	var googleMap = map.data('gmap');

	if ( typeof map.data('gmapMarkers') == 'undefined' ) {
		// First init!
		var features = [
			{
				position: new google.maps.LatLng( sixScript.gmap_lat, sixScript.gmap_long ),
				type: 'info',
				title: sixScript.blogname ,
				animation: google.maps.Animation.DROP
			}
		];
		var icon = {
			url: sixScript.gmap_icon,
			scaledSize: new google.maps.Size(64,64),
			origin: new google.maps.Point(0,0),
			anchor: new google.maps.Point(32,32)
		};
		// Create markers.
		map.data('gmapMarkers',[]);

		features.forEach(function(feature) {
		  var marker = new google.maps.Marker({
			position: feature.position,
			map: googleMap,
			icon: icon,
			animation: feature.animation,
			title: feature.title,
			clickable: true
		  }).addListener('click', function(e) {
					var pid = sixScript.gmap_placeid,
						destination = ( pid && pid.length? pid : sixScript.gmap_lat + ',' + sixScript.gmap_long),// sixScript.blogname ),
						url = "https://www.google.com/maps/dir/?api=1&destination=" + destination + "&destination_place_id=" + pid;
						window.open(url);
			});
		  map.data('gmapMarkers').push(marker);
		});

	} else {

		// reinit
		googleMap.setCenter( new google.maps.LatLng( sixScript.gmap_lat, sixScript.gmap_long ) );
		map.data('gmapMarkers')[0].setAnimation( google.maps.Animation.DROP );
		
	}
	
}

// jQuery Easings
$.extend( $.easing, {
	easeOutCubic: function (x, t, b, c, d) {
			return c*((t=t/d-1)*t*t + 1) + b;
		},
	easeInQuad: function (x, t, b, c, d) {
	    return c*(t/=d)*t + b;
	}
});

// Age Verification consented
window.scdAgeVerification = function ( consent ) {
	
	if ( consent ) {
		
		localStorage.ageVerified = 'true';
		sessionStorage.hasVisited = 'true';
		
		// Close off-canvas
		$('#off-canvas').foundation('close');

		// follow link after off-canvas closes
		$('#off-canvas').one('closed.zf.offCanvas', function () {
			document.documentElement.classList.remove('verify-age');
			$(document.documentElement).trigger('ageVerified');
		});		
		
	}
	
}

})(jQuery);